import pick from 'lodash/pick';

import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const getInputContainerClassName = props => (
  classNames(props.wrapperClassName, {
    'has-error': props.showAlertTriangle
  })
);

const InputComponent = props => (
  <div className={getInputContainerClassName(props)} data-test="inputComponent">
    <label className={props.labelClassName} htmlFor={props.id}>
      {props.label}

      {props.showAlertTriangle &&
      <i
        className={props.iClassName}
        onMouseEnter={props.onAlertTriangleMouseEnter}
        onMouseLeave={props.onAlertTriangleMouseLeave}
      />
      }
    </label>

    <input
      id={props.id || props.name}

      {...pick(props, [
        'type',
        'step',
        'value',
        'pattern',

        'min',
        'max',

        'onBlur',
        'onFocus',
        'onChange',
        'disabled'
      ])}
      title=""
      className={props.inputClassName}
    />

    {props.showAlertTriangle && props.isPopupVisible &&
    <span className="main-tooltip main-input__tooltip" data-test="inputError">
      {props.error}
    </span>
    }
  </div>
);

InputComponent.propTypes = {
  // values
  id: PropTypes.string,
  error: PropTypes.string,

  name: PropTypes.string.isRequired,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.array]).isRequired,

  isPopupVisible: PropTypes.bool.isRequired,
  showAlertTriangle: PropTypes.bool.isRequired,

  inputClassName: PropTypes.string,
  labelClassName: PropTypes.string,
  wrapperClassName: PropTypes.string,
  iClassName: PropTypes.string,

  // callbacks
  onAlertTriangleMouseEnter: PropTypes.func.isRequired,
  onAlertTriangleMouseLeave: PropTypes.func.isRequired
};

InputComponent.defaultProps = {
  id: null,
  error: null,

  labelClassName: 'main-input__label',
  inputClassName: 'main-input__input',

  wrapperClassName: 'flex-grow flex-basis mb-15 relative',
  iClassName: 'icon icon-alert-triangle'
};

export default InputComponent;
